import React from 'react'

import { Item } from './styles'

function NoOptionsMessage(props: { children: React.ReactNode }) {
  return <Item {...props} />
}

export default NoOptionsMessage
